/**
 * Detects whether the current OS/browser renders unicode country flag emojis.
 *
 * On Windows the system emoji font (Segoe UI Emoji) does not include flag
 * glyphs, so a flag like '🇨🇦' falls back to the two regional-indicator
 * letters ('CA') side by side. Most other platforms (macOS, iOS, Android,
 * most Linux distros, ChromeOS) ship a flag-capable emoji font.
 *
 * The detection technique: render the flag and the equivalent letter pair
 * to a canvas with the same font/size, and compare their rasterised pixels.
 * If they match, the platform is rendering the flag as letters and we should
 * hide it. If they differ, a real flag glyph is being drawn.
 *
 * The result is exposed as `document.documentElement.dataset.flagEmojiSupported`
 * (`'true'` or `'false'`) so CSS rules under
 * `html[data-flag-emoji-supported="true"]` can opt in to flag rendering.
 *
 * Idempotent: subsequent loads short-circuit via `window.__bunningsFlagEmojiSupportChecked`.
 */
(function detectFlagEmojiSupport() {
  if (window.__bunningsFlagEmojiSupportChecked) return;
  window.__bunningsFlagEmojiSupportChecked = true;

  const root = document.documentElement;
  let supported = false;

  try {
    const canvas = document.createElement('canvas');
    canvas.width = 16;
    canvas.height = 16;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) {
      root.dataset.flagEmojiSupported = 'false';
      return;
    }

    ctx.font = '16px sans-serif';
    ctx.textBaseline = 'top';
    ctx.fillText('\uD83C\uDDE8\uD83C\uDDE6', 0, 0);
    const flagPixels = ctx.getImageData(0, 0, 16, 16).data;

    ctx.clearRect(0, 0, 16, 16);
    ctx.fillText('CA', 0, 0);
    const lettersPixels = ctx.getImageData(0, 0, 16, 16).data;

    let differs = false;
    for (let i = 0; i < flagPixels.length; i += 4) {
      if (
        flagPixels[i] !== lettersPixels[i] ||
        flagPixels[i + 1] !== lettersPixels[i + 1] ||
        flagPixels[i + 2] !== lettersPixels[i + 2] ||
        flagPixels[i + 3] !== lettersPixels[i + 3]
      ) {
        differs = true;
        break;
      }
    }
    supported = differs;
  } catch {
    supported = false;
  }

  root.dataset.flagEmojiSupported = supported ? 'true' : 'false';
})();
